import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./HistoryCard.module.css";

export default function PHistoryCard(props) {
    const [tg, i18n] = useTranslation("global");

    let redeemedStatus = props.redeemed === true ? tg("stats.card.redeemStatusTrue") : tg("stats.card.redeemStatusFalse");


    return (
        <div className={classes.box}>
        <h1>{props.title}</h1>
        <p>{tg("stats.card.dateTime")}: {props.date}</p>
        <p>{tg("stats.card.pointValue")}: {props.pointValue}</p>
        <p>{redeemedStatus}</p>
        </div>
    );
    } 